import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '../lib/auth'
import { AppShell } from '../shell/app-shell'
import { panelSearchSchema } from '../shell/panel-state'

/**
 * `_authed` - the authenticated cockpit layout. Validates the record-panel
 * search params (`?panel` / `?panelId`) for every child route and renders the
 * persistent `AppShell`. In mock mode identity is mocked (the dev session holds
 * all scopes, set at boot); in live mode this is where the Cognito JWT is
 * validated (PLAN-02).
 */
export const Route = createFileRoute('/_authed')({
  validateSearch: panelSearchSchema,
  beforeLoad: () => {
    if (!isAuthenticated()) throw redirect({ to: '/login' })
  },
  component: AppShell,
})
